/* eslint-disable no-undef */
/* eslint-disable func-names */
import { getServerTimestamp } from '../../../Services/@sgorg/game-backend-client-mock';
import { Window } from '../../../00_IMMEDIATE/Window';
import OMT_UI_ScrollArea from '../../../OMT_UI/Scroll/OMT_UI_ScrollArea';
import OMT_UI_ScrollBarConfig from '../../../OMT_UI/Scroll/OMT_UI_ScrollBarConfig';
import SpecialDeal from './Shop_SpecialDeal';
import ShopEntry from './Shop_Entry';
import ShopUtils, { SHOP_EVENT_KEYS } from './Shop_Utils';

const SCROLL_AREA_RECT = new Phaser.Rectangle(-200, -220, 405, 570);
const FRAME_AREA_RECT = new Phaser.Rectangle(-282, -370, 500, 840);
const MAX_SHOP_ASSETS = 6;
const NO_SCROLL_WIDTH_ADJUST = 22;

export default class Window_coinShop extends Window {
  /**
   * Ye coin shoppe
   * @param {Phaser.World} parent
   * @param {Object} options
   * @param {boolean} options.hideFreeGift
   */
  constructor(parent, options) {
    super(parent);
    // set default options
    if (options == null) options = {};
    if (options.hideFreeGift == null) Object.assign(options, { hideFreeGift: true });

    this._hideFreeGift = options.hideFreeGift; // determine wether we should show the free gift
    this._special = {}; // The special deal, with the fancy assets. Currently a blank for destruction calls
    this._items = []; // The items that are laid out. Not as fancy ^
    this._attemptToLoadShop = _.debounce(this._loadShop, 100); // Just in case race conditions happen
    this._waitingIcon = undefined; // The waiting icon
    this._dealContainer = undefined; // The container that holds all the deals
    this._catalog = undefined; // The given catalog
    this._shopIsDone = false; // A flag to not re-initialize the shop again
    this._catalogReady = false; // A flag for when the catalog is ready
    this._assetsReady = false; // A flag for when the main assets are ready
    this._runningEvent = undefined; // A collection of events that are running
    this._allTweens = []; // All tweens saved for destruction

    this._initAssets(); // Draw the assets
    this.onFinishedEnter.addOnce(this._collectShopCatalog.bind(this)); // When the window entering is done, get the catalog

    // shift window in game scene
    if (game.state.current === 'Game') {
      this.y += G.WindowMgr.Constants.WorldVerticalOffset;
    }
  }

  /**
   * Draws the background and the waiting icon.
   * Then tries to load the shop
   */
  _initAssets() {
    this._drawBackground();
    this._initWaitingIcon();
    this._assetsReady = true;
    this._attemptToLoadShop();
  }

  /**
   * Adds in the waiting icon. It spins!
   */
  _initWaitingIcon() {
    this._waitingIcon = new G.WaitingIcon(0, 125, 'waiting_icon'); // Loading...
    this.addChild(this._waitingIcon);
  }

  /**
   * Function that tweens out the icon
   */
  _removeWaitingIcon() {
    if (this._waitingIcon) {
      const tw = game.add.tween(this._waitingIcon)
        .to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.InOut, true);
      tw.onComplete.addOnce(() => {
        if (this._waitingIcon) {
          if (this._waitingIcon.parent) {
            this._waitingIcon.parent.removeChild(this._waitingIcon);
          }
          this._waitingIcon.destroy();
        }
        this._waitingIcon = null;
      });
      this._allTweens.push(tw);
    }
  }

  /**
   * create scrollable content area
   */
  _initScrollArea(rect) {
    const scrollBarConfig = new OMT_UI_ScrollBarConfig(12, 5, 0, null, null, null, 'shop2', 'scrollbar_slide', false, 'scrollbar_bg');
    this._scrollArea = new OMT_UI_ScrollArea(rect, scrollBarConfig);
    this._scrollArea.autoResize = false;
    this._dealContainer.addChild(this._scrollArea);
    this._scrollArea.updateScrollBar();
  }

  /**
   * show / create shop items
   */
  _showShopItems() {
    this._dealContainer = new Phaser.Group(game, this); // The main container that shows all the deals
    this._dealContainer.alpha = 0; // Its hidden at first to try to make the shop load/look faster
    this._dealContainer.visible = false;
    const itemsContainer = new Phaser.Group(game, null); // The items container that gets scrolled around
    // filter catalog for the users tier
    const filteredCatalog = ShopUtils.filterCurrentTier(this._catalog);

    // show special deal if defined
    let targetEvent = null;
    if (this._runningEvent) {
      // eslint-disable-next-line prefer-destructuring
      targetEvent = this._runningEvent; // Ignore all other events.
    }
    let deal = ShopUtils.getSpecialDeal(filteredCatalog, targetEvent);
    if (!deal && targetEvent) { // If there was no deal when looking for an event deal, fall back to regular deals
      targetEvent = null;
      deal = ShopUtils.getSpecialDeal(filteredCatalog);
    }
    if (deal) {
      this._special = new SpecialDeal(window.game, { // Special fancy deals!!
        catalog: deal,
        event: targetEvent,
        // catalog: {
        //   description: "x3",
        //   imageURI: null,
        //   price: "C$4.00",
        //   priceCurrencyCode: "CAD",
        //   productID: "t1_first_0k_b2_3_b4_3_b7_2",
        //   title: "First Time Offer 05",
        // },
      });
      this._special.y -= Math.round(this._special.calculatedHeight * 0.63);
      this._dealContainer.addChild(this._special); // Its part of the main container, not the scrolling container
    }

    // filter catalog for the current tier
    const filteredCatalogCoins = ShopUtils.filterCoinDeals(filteredCatalog);

    const isOnCooldown = G.saveState.getUserCooldownRemaining('3h_gift', '') === 0;

    const thereIsAGift = OMT.feature.is3hGiftInShop() && OMT.feature.getFeature3hGift() && OMT.feature.getFeature3hGiftActiveByLevel() && isOnCooldown && !this._hideFreeGift;
    let nextY = thereIsAGift ? 20 : 0; // Give a gap of 20/0 at the beginning
    const entryPadding = 35; // The space between each padding
    const entryCenterOffset = 0; // Horizontal offset for each entry
    let entryWidth = 0; // Need this for later

    for (let i = 0; i < filteredCatalogCoins.length; i++) {
      let entry; // The entry is... an entry!
      // 3 hour gift item
      if (thereIsAGift && i === 0) { // replace with CD check
        const icon = 'gift_full';
        const item = { title: `${OMT.language.getText('Free')}!`, price: OMT.language.getText('Claim'), description: '' };
        entry = new ShopEntry(game, { // Free gift entry
          icon,
          item,
          buttonType: 'orange',
          buttonTextStyle: 'shop2-FreeClaim',
          buttonCallBack: () => { // Does a lot of stuff.
            const giftConfig = G.Utils.clone(G.json.settings.GingyGiftSettings);
            const giftSeed = G.saveState.getCooldownSeed('3h_gift_pick', 1000 * 60 * 60 * 3);

            // eslint-disable-next-line prefer-const
            const onClaim = async () => {
              G.sb('mapGiftCollect').dispatch();
              G.saveState.setUserCooldown('3h_gift', '', 1000 * 60 * 60 * 3, true);
              await OMT.notifications.scheduleGameTriggeredMessage(OMT.envData.settings.user.userId, 'HourlyGift', 3 * 60 * 60, null);
              G.sb('pushWindow').dispatch(['coinShop']);
            };

            giftConfig.onClaim = onClaim;
            giftConfig.gifts = this._getGifts(giftSeed, giftConfig);
            giftConfig.placement = G.BuildEnvironment.adPlacements.double3hGift;
            if (!game.incentivised() || !G.featureUnlock.mapGiftDoubling) {
              giftConfig.monetiseType = false;
            }
            giftConfig.twoFrameOpen = G.OMTsettings.elements.gifts.twoFrameOpen;

            G.sb('pushWindow').dispatch(['gift', giftConfig], false, G.WindowMgr.LayerNames.BelowHeaderPanel);
            this.closeWindow();
          },
          iconAnimation: this._animateEntryIcon.bind(this),
        });
      } else { // normal shop items
        const icon = `shop_deal_${Math.min(i + 1, MAX_SHOP_ASSETS)}`; // Item numbers past the MAX_SHOP_ASSETS will always look the best
        entry = new ShopEntry(game, { // Defaults will handle the rest
          icon,
          item: filteredCatalogCoins[i],
        });
      }

      // All entries will
      entry.x = Math.round(entryCenterOffset); // be offset a bit
      entry.y = Math.round(nextY + entry.calculatedHeight / 2); // Positioned
      nextY += entry.calculatedHeight + entryPadding; // Calculate the next position
      if (entryWidth < entry.calculatedWidth) { // Save the width because I'll need it
        entryWidth = entry.calculatedWidth;
      }
      this._items.push(entry); // Save reference
      itemsContainer.addChild(entry); // Add it in
    }
    itemsContainer.x += Math.round(entryWidth / 2); // Offset items by half an entry because scrolling container's 0, 0 is top left aligned and not center

    // Make the scroll component
    // Is there a special deal? If not, take up the whole space
    const weirdHeightCalculation = thereIsAGift ? 0.53 : 0.61;
    const targetY = this._special.calculatedHeight ? this._special.y + this._special.calculatedHeight * weirdHeightCalculation : SCROLL_AREA_RECT.y;
    const scrollDimensions = new Phaser.Rectangle(SCROLL_AREA_RECT.x, targetY, SCROLL_AREA_RECT.width, 0);
    scrollDimensions.height = SCROLL_AREA_RECT.height - G.OMTsettings.elements.windowNineSlice.bottom - scrollDimensions.y;
    scrollDimensions.height += G.OMTsettings.elements.Window_shop2.scrollHeightOffset || 0;
    this._initScrollArea(scrollDimensions);
    this._scrollArea.content.addChild(itemsContainer);

    // Entry the containers
    this._dealContainer.visible = true;
    const tw = game.add.tween(this._dealContainer) // Tweens in
      .to({ alpha: 1 }, 200, Phaser.Easing.Sinusoidal.InOut, true);
    this._allTweens.push(tw);

    // force a scroll bar update, adjust the content scale if the scrollbar isnt visible
    this._scrollArea.updateScrollBar();
    this._scrollArea.update();
    this._scrollArea.scale.x = this._scrollArea.isScrollBarVisible ? 1 : (SCROLL_AREA_RECT.width + NO_SCROLL_WIDTH_ADJUST) / SCROLL_AREA_RECT.width;
  }

  /**
   * Collects catalog from FB and other async notes that need to be collected
   */
  async _collectShopCatalog() {
    if (await OMT.feature.getEventPostcardFeature()) {
      const curTime = await getServerTimestamp();
      let endTime = 0;
      try {
        endTime = G.featureUnlock.eventPostcard.range.end;
      } catch (err) {
        endTime = curTime + (48 * 1000 * 60 * 60); // 2 days from now
      }
      const timeout = (endTime - curTime) / 1000;
      this._runningEvent = {
        key: SHOP_EVENT_KEYS.POSTCARD,
        packageId: G.OMTsettings.postcardEvent.eventId,
        firstTimeBuyerId: G.OMTsettings.postcardEvent.shop.firstTimeBuyerKey + G.OMTsettings.postcardEvent.eventId,
        timeout,
      };
    }
    this._catalog = await OMT.payments.getCatalogAsync();
    if (!this._catalog || this._catalog.length === 0) { // If theres no catalog
      if (this._scrollArea) this._scrollArea.visible = false;
      this._removeWaitingIcon();
      this._showCouldNotLoadCatalogError();
    } else { // There is!? Try to load the shop
      this._catalogReady = true;
      this._attemptToLoadShop();
    }
  }

  /**
   * show shop items when everything is ready
   */
  _loadShop() {
    // Assets, catalog ready!? And we didn't show the shop yet!?
    if (this._catalogReady && this._assetsReady && !this._shopIsDone) {
      this._shopIsDone = true;
      try { // IF ANYTHING BREAKS, JUST SHOW THE ERROR SCREEN
        this._showShopItems();
      } catch (err) {
        console.log('Shop has encountered an error!');
        console.error(err);
        this._showCouldNotLoadCatalogError();
      }
      this._removeWaitingIcon(); // Not needed anymore
    }
  }

  /**
   * show error when catalog load failed
   */
  _showCouldNotLoadCatalogError() {
    if (this._dealContainer) { // Attempts to remove the deal container that has all the deals
      this.removeChild(this._dealContainer);
    }
    this._errorTxt = new G.Text(0, -50, OMT.language.getText('Something went wrong! Please, try again.'), {
      style: 'font-white-blue-out',
      fontSize: '38px',
    }, 0.5, 420, 300, true, 'center');
    this.addChild(this._errorTxt);
  }

  /**
   * get free gifts
   * @param {number} giftSeed
   * @param {Object} giftConfig
   */
  _getGifts(giftSeed, giftConfig) {
    game.rnd.sow([giftSeed]);
    if (G.IAP) {
      return [G.gift.getGift('3H_Gift')];
    }
    if (game.rnd.realInRange(0, 1) < giftConfig.chanceToGetBooster) {
      return [
        G.gift.getGift('normalsGingyGift_boosters', true),
      ];
    }
    return [
      G.gift.getGift('normalsGingyGift_coins', true),
    ];
  }

  /**
   * Draws the window background
   * And the header
   * And the close button
   */
  _drawBackground() {
    this._bg = this.addGeneric9SliceBackground(FRAME_AREA_RECT.width, FRAME_AREA_RECT.height);
    this._bg.position.y += 100;
    const topBarOffset = G.OMTsettings.elements.Window_shop2.topBarOffset ? G.OMTsettings.elements.Window_shop2.topBarOffset : 0;
    const bgContainer = new Phaser.Group(game, this._bg);
    bgContainer.y = -(FRAME_AREA_RECT.height / 2) + topBarOffset;
    const bgHead = G.makeImage(0, 0, 'store_bg', 0.5, bgContainer);
    if (G.OMTsettings.elements.Window_shop2.headerImgAdjustments) {
      _.merge(bgHead, G.OMTsettings.elements.Window_shop2.headerImgAdjustments);
    }

    const topTextOffset = G.OMTsettings.elements.Window_shop2.topBarTextOffset ? G.OMTsettings.elements.Window_shop2.topBarTextOffset : 0;
    const headText = new G.Text(
      bgContainer.x,
      bgContainer.y + topTextOffset,
      OMT.language.getText('Store'),
      G.OMTsettings.elements.Window_shop2.headerFontStyle ? G.OMTsettings.elements.Window_shop2.headerFontStyle : G.OMTsettings.global.window.title.textStyle,
      0.5,
      bgContainer.width * 0.7,
      bgContainer.height * 0.7,
      true,
      'center',
    );
    this._bg.addChild(headText);
    this.addCloseButton(FRAME_AREA_RECT.x + FRAME_AREA_RECT.width, FRAME_AREA_RECT.y + 50, () => {
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.CloseShop);
    });
  }

  /**
   * animate a icon with a pulse animation
   * @param {Object} icon
   */
  _animateEntryIcon(icon) {
    const animTime = 900;
    const delayTime = 1000 - animTime;
    const originalScale = icon.scale.x;
    const bigScale = originalScale + 0.05;
    const bounceAnim = game.add.tween(icon.scale) // Initial tween for the raising action
      .to({ x: [bigScale, originalScale], y: [bigScale, originalScale] }, animTime, Phaser.Easing.Back.InOut, true);
    const subtlePause = game.add.tween(icon) // Pause...
      .to({ y: icon.y }, delayTime, Phaser.Easing.Linear.None);
    bounceAnim.chain(subtlePause);
    subtlePause.chain(bounceAnim);

    this._allTweens.push(bounceAnim);
    this._allTweens.push(subtlePause);
  }

  /**
   * destruction method
   */
  destroy() {
    this._removeWaitingIcon();
    if (this._special && this._special.destroy) {
      this._special.destroy();
    }
    _.forEach(this._items, (item) => { // Attempts to destroy these too
      if (item && item.destroy) {
        item.destroy();
      }
    });
    _.forEach(this._allTweens, (tween) => { // Stops every tween
      tween.stop();
    });

    super.destroy();
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.coinShop = Window_coinShop;
